import { useEffect } from 'react';

export const useGenuinelyEmpty = ({ table, isFetching, isError, total }, onEmptyChange) => {
  const isGenuinelyEmpty =
    !isFetching && !isError && total === 0 && !table.search && !table.hasActiveFilters;

  useEffect(() => {
    onEmptyChange?.(isGenuinelyEmpty);
  }, [onEmptyChange, isGenuinelyEmpty]);

  return isGenuinelyEmpty;
};
